module.exports = __webpack_public_path__ + "img/bigdata.png";